<template>
<div>
  <div class="page">
    <div>Bulletin will go here</div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'

export default Vue.component('RouteBulletin', {
  computed: {
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.page {
  min-height: 100vh;
  background: $color-white;
  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/routes/route-bulletin.vue